import { DateBox, SelectBox } from "devextreme-react";
import { NOTIFICATION } from "../data";
import { updateNotification, updateNotificationDate } from "./Redux/Tracker";
import { useDispatch } from "react-redux";
import { useState } from "react";

export default function NotificationComponent(props) {
  const { trainingTracker } = props;

  const dispatch = useDispatch();

  const onNotificationValueChanged = (e) => {
    dispatch(
      updateNotification({
        notif: e.value,
      })
    );
  };

  const onNotificationDateValueChanged = (e) => {
    dispatch(
      updateNotificationDate({
        notifDate: e.value ? e.value : null,
      })
    );
  };

  return (
    <>
      <SelectBox
        dataSource={NOTIFICATION}
        displayExpr={"name"}
        valueExpr={"id"}
        style={{
          float: "left",
          width: "35%",
          marginRight: "3px",
        }}
        readOnly={trainingTracker.dueDate ? false : true}
        value={trainingTracker.notif}
        showClearButton={true}
        onValueChanged={onNotificationValueChanged}
      />
      {trainingTracker.notif == -1 && (
        <DateBox
          type="datetime"
          style={{
            float: "left",
            width: "60%",
          }}
          displayFormat={"yyyy-MM-ddTHH:mm:ss"}
          dateSerializationFormat={"yyyy-MM-ddTHH:mm:ss"}
          showClearButton={true}
          readOnly={trainingTracker.dueDate ? false : true}
          value={trainingTracker.notifDate}
          onValueChanged={onNotificationDateValueChanged}
        />
      )}
    </>
  );
}
